import React from "react";
import { Routes, Route } from "react-router-dom";
import CommissionsListPage from "../pages/Comissions/CommissionsListPage";

const CommissionsRouter = () => {
  return (
    <Routes>
      <Route exact path="/" element={<CommissionsListPage />} />
      <Route path="*" element={<CommissionsListPage />} />
    </Routes>
  );
};

export default CommissionsRouter;
